import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from '@trileuco/triskel-react-ui/components/i18n'

import BookableWysiwygBlock from './BookableWysiwygBlock'

const BookableItineraryBlock = ({ bookable }) => {
  const { msg } = useIntl({ scope: '' })
  return (
    <BookableWysiwygBlock
      title={msg({ id: 'itinerary' })}
      content={bookable.info.itinerary}
    />
  )
}

BookableItineraryBlock.propTypes = {
  bookable: PropTypes.shape()
}

BookableItineraryBlock.displayName = 'BookableItineraryBlock'

export default BookableItineraryBlock
